export function alertModuleFactory(i18n, Utils) {
  return {
    namespaced: true,
    state: {
      type: null,
      message: null
    },
    actions: {
      success({commit}, message) {
        commit('success', message);
      },
      error({commit}, {message, error}) {
        if (error) {
          let errorMessage = i18n.t('messages.generic');

          if (!Utils.isBlank(error.response.data.message)) {
            errorMessage = error.response.data.message;

          } else if (i18n.te(`http.${error.response.status}`)) { // check existence
            errorMessage = i18n.t(`http.${error.response.status}`);
          }
          if (message) {
            commit('error', message + ": " + errorMessage);
          } else {
            commit('error', errorMessage);
          }
        } else {
          commit('error', message);
        }
      },
      clear({commit}, message) {
        commit('success', message);
      }
    },
    mutations: {
      success(state, message) {
        state.type = 'alert-success';
        state.message = message;
      },
      error(state, message) {
        state.type = 'alert-error';
        state.message = message;
      },
      clear(state) {
        state.type = null;
        state.message = null;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/alert.module.js